/**
 * @Description 调试路由 （调样式的时候最好先把水印注掉）
 * /ppt?categoryName=中餐厅&categoryNum=0401&cityId=87&districtId=821&latitude=30.41875&longitude=120.298501&poiName=杭州市临平区人民政府&range=500&saveRecord=false&type=1&reportRecordId=3052&token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJpZD03NTQ4MyBlbXBsb3llZUlkPTIyMTAwNSB0ZW5hbnRJZD00NjMxNSBjbGllbnRLZXk9MTAwMTIxMyBjcmVhdGVBdD0yMDI0LTAyLTIwIDE0OjE4OjQ3IiwibG9jYXRpb24iOnRydWUsImVtcGxveWVlSWQiOjIyMTAwNSwiaWQiOjc1NDgzLCJleHAiOjE3MDkwMTQ3Mjd9.tCtLUfFOw9CLAkfQSSpXJT0qmq_N2b2XwP3sIdtX2wk
 */
/**
 * @Description 关于打印tips
 * 1、在div中单独使用span对某部分进行加粗时，要用font-weight：bold不能用500
 */

import { FC, useEffect, useState } from 'react';
import styles from './entry.module.less';
import PageOne from './components/pageOne';
import PageThree from './components/pageThree';
import PageFour from './components/pageFour';
import PageFive from './components/PageFive';
import LastPage from './components/LastPage';
import PageSix from './components/PageSix';
import { useMethods } from '@lhb/hook';
import { useLocation } from 'react-router-dom';
import { isNotEmptyAny, urlParams } from '@lhb/func';
import { getEnvironmentAnalysis, getEnvironmentReport, getExclusiveRecord, getLocationCode, getStoreOperation, getStoreSuviveRate } from '@/api/pdf';
import PageTwo from './components/pageTwo';
import PlaceComment from './components/PlaceComment';
import LivePictures from './components/LivePictures';
import { QiniuImageUrl } from '@/utils/qiniu';
import { nodeWatermark } from '@/common/utils/tools';
import PassengerFlowPortrait from './components/PassengerFlowPortrait';
import PassengerFlowPortraitTwo from './components/PassengerFlowPortraitTwo';
import PassengerFlowPortraitThree from './components/PassengerFlowPortraitThree';
import PeopleFlow from './components/PeopleFlow';

const LocationSrounding: FC<any> = () => {
  const [data, setData] = useState<any>();
  const [flowData, setFlowData] = useState<any>(); // 客群画像数据
  const [nameObj, setNameObj] = useState<any>();
  const [lnglat, setLnglat] = useState<any>();
  const [qrCode, setQRCode] = useState<any>();
  const [range, setRange] = useState<any>();
  const [recommendRange, setRecommendRange] = useState<number>(0); // 位置推荐辐射范围
  const [exclusiveRecord, setExclusiveRecord] = useState<any>(); // 专属报告内容
  const [isSurrounding, setIsSurrounding] = useState<boolean>(false); // 是否是商场洞察的报告，通过参数type判断
  const [horizontalImgs, setHorizontalImgs] = useState<any>([]); // 横向图片集合
  const [verticalImgs, setVerticalImgs] = useState<any>([]); // 纵向/方形图片集合
  const [hasLBSData, setHasLBSData] = useState<boolean>(false); // 商场洞察-是否有LBS数据
  const [isSurInfoVoNull, setIsSurInfoVoNull] = useState<boolean>(false); // 住宅配套数据是否全为空（兼容后端特殊逻辑）

  const { search } = useLocation();
  const info = urlParams(search);

  const methods = useMethods({
    // 获取pdf详情信息
    async getPDFInfo() {
      const { token, exclusiveAnalysisRecordUuid, originId, ...params } = info;

      if (originId && originId !== 'null') {
        params.originId = originId;
      }

      // const testParams = {
      //   range: 500,
      //   poiName: '%E6%9D%AD%E5%B7%9E%E5%B8%82%E4%B8%B4%E5%B9%B3%E5%8C%BA%E4%BA%BA%E6%B0%91%E6%94%BF%E5%BA%9C',
      //   latitude: 30.41875,
      //   longitude: 120.298501,
      //   cityId: 87,
      //   saveRecord: false,
      //   districtId: 821,
      //   categoryName: 'KTV',
      //   categoryCode: '080301%2C080302',
      // };

      const totalInfo = await getEnvironmentReport({ ...params }, token);
      const storeSurvivalRateInfo = await getStoreSuviveRate({ ...params }, token);

      let storeOprationInfo: any = {};

      await getStoreOperation({ ...params }, token).then((res) => {
        storeOprationInfo = res;
      });

      // 获取客群画像数据
      if (Number(params.type) === 2) {
        const flowData = await getEnvironmentAnalysis({ ...params }, token);
        setFlowData(flowData);
        const { normalInfoVO = {} } = flowData || {};
        const { age = [], industry = [], married = [], sex = [] } = normalInfoVO || {};
        console.log(age.length && industry.length && married.length && sex.length);
        setHasLBSData(age.length && industry.length && married.length && sex.length);
      }

      // 获取小程序二维码
      const { url } = await getLocationCode({ reportRecordId: params.reportRecordId }, token);

      const name = decodeURIComponent(totalInfo?.placeInfoVO?.name);
      const rangeName = `${name}周边${Number(params.range) < 1000 ? params.range + 'm' : params.range / 1000 + 'km'}`;

      // 如果路径中包含exclusiveAnalysisRecordUuid参数则代表是专属报告进入的
      if (exclusiveAnalysisRecordUuid && exclusiveAnalysisRecordUuid !== 'null') {
        const { pics, ...exclusiveRecord } = await getExclusiveRecord({ uuid: exclusiveAnalysisRecordUuid }, token);

        const newPics = pics?.map((item) => {
          return QiniuImageUrl(item);
        });

        setExclusiveRecord(exclusiveRecord);

        if (newPics && newPics.length) {
          await this.categorizeImagesByAspectRatio(newPics);
        }
      }

      setRange(Number(params.range));
      setRecommendRange(Number(params.businessCircleRange));
      setIsSurrounding(Number(params.type) === 2);
      setNameObj({ name, rangeName });
      setLnglat({
        lat: params?.latitude,
        lng: params?.longitude
      });
      setQRCode(url);

      const isSurInfoVoNull = this.isObjectEmpty(totalInfo?.surroundingInfoVO);

      if (!isSurInfoVoNull && isNotEmptyAny(totalInfo?.surroundingInfoVO)) {
        setIsSurInfoVoNull(false);
      } else {
        setIsSurInfoVoNull(true);
      }

      setData({ ...totalInfo, storeSurvivalRateInfo, storeOprationInfo });

    },
    isObjectEmpty(obj: any) {
      if (typeof obj !== 'object' || obj === null) {
        return true;
      }

      for (const key in obj) {
        if (obj[key] !== null) {
          return false;
        }
      }

      return true;
    },
    // 根据图片尺寸处理图片
    async categorizeImagesByAspectRatio(imageUrls) {
      const wideImages: any = [];
      const tallImages: any = [];

      const loadImage = (imageUrl) => {
        return new Promise<void>((resolve, reject) => {
          const img = new Image();

          img.src = imageUrl;

          img.onload = function() {
            const width = img.width;
            const height = img.height;

            if (width > height) {
              wideImages.push(imageUrl);
            } else {
              tallImages.push(imageUrl);
            }

            resolve();
          };

          img.onerror = function() {
            reject(new Error(`Failed to load image: ${imageUrl}`));
          };
        });
      };

      const loadAllImages = async () => {
        const loadPromises = imageUrls.map((imageUrl) => loadImage(imageUrl));
        await Promise.all(loadPromises);
      };

      await loadAllImages();

      const combinedTallImages: any = [];
      for (let i = 0; i < tallImages.length; i += 2) {
        combinedTallImages.push(tallImages.slice(i, i + 2));
      }

      console.log(wideImages, combinedTallImages);
      setHorizontalImgs(wideImages);
      setVerticalImgs(combinedTallImages);
    },
  });

  useEffect(() => {

    if (!info) return;

    methods.getPDFInfo();

    nodeWatermark({
      watermark_txt: 'LOCATION 商业直租',
      // watermark_x_space: 30,
      watermark_position: 'fixed',

      watermark_x: 0, // 水印起始位置x轴坐标
      watermark_y: 0, // 水印起始位置Y轴坐标
      watermark_rows: 15, // 水印行数
      watermark_cols: 10, // 水印列数
      watermark_x_space: 120, // 水印x轴间隔
      watermark_y_space: 80, // 水印y轴间隔
      watermark_color: '#dddddd', // 水印字体颜色
      watermark_alpha: 0.48, // 水印透明度
      // watermark_color: 'red', // 水印字体颜色
      // watermark_alpha: 0.9, // 水印透明度
      watermark_fontsize: '12px', // 水印字体大小
      watermark_font: '微软雅黑', // 水印字体
      watermark_width: 140, // 水印宽度
      watermark_height: 15, // 水印长度
      watermark_angle: 15, // 水印倾斜度数
    }as any, 'body');

  }, []);
  return (
    <div className={styles.container}>
      <div className={styles['page']}>
        <PageOne
          data={data?.placeInfoVO}
          nameObj={nameObj}
          qrCode={qrCode}/>
      </div>

      {isNotEmptyAny(exclusiveRecord) ? <div className={styles['page']}>
        <PlaceComment
          rangeName={nameObj?.rangeName}
          range={range}
          lnglat={lnglat}
          data={exclusiveRecord}/>
      </div> : <></>}

      {horizontalImgs.length ? horizontalImgs.map((item, index) => {
        return (
          <div className={styles['page']} key={index}>
            <LivePictures img={item} type='horizon'/>
          </div>
        );
      }) : <></>}

      {verticalImgs.length ? verticalImgs.map((item, index) => {
        return (
          <div className={styles['page']} key={index}>
            <LivePictures imgList={item} type='vertical'/>
          </div>
        );
      }) : <></>}

      <div className={styles['page']}>
        <PageTwo
          peopleInfoVO={data?.peopleInfoVO}
          rangeName={nameObj?.rangeName}
          lnglat={lnglat}
          reportConclusion={data?.reportConclusion}
          range={range}
          recommendRange={recommendRange}
          poiName={nameObj?.name}
          isSurrounding={isSurrounding}/>
      </div>

      <div className={styles['page']}>
        <PageThree
          peopleInfoVO={data?.peopleInfoVO}
          surroundingInfoVO={data?.surroundingInfoVO}
          rangeName={nameObj?.rangeName}
          qrCode={qrCode}
          peopleStatisticsVO={data?.peopleStatisticsVO}/>
      </div>

      {isSurrounding && hasLBSData ? <>
        <div className={styles['page']}>
          <PassengerFlowPortrait
            rangeName={nameObj?.rangeName}
            flow={flowData?.flow}
            normalInfoVO={flowData?.normalInfoVO}
            workdayAndHolidayInfoVO={flowData?.workdayAndHolidayInfoVO}/>
        </div>

        <div className={styles['page']}>
          <PassengerFlowPortraitTwo
            rangeName={nameObj?.rangeName}
            workdayAndHolidayInfoVO={flowData?.workdayAndHolidayInfoVO}/>
        </div>

        <div className={styles['page']}>
          <PassengerFlowPortraitThree
            rangeName={nameObj?.rangeName}
            normalInfoVO={flowData?.normalInfoVO}/>
        </div>
      </> : <div className={styles['page']}>
        <PeopleFlow
          rangeName={nameObj?.rangeName}
          peopleStatisticsVO={data?.peopleStatisticsVO}/>
      </div>}

      {isSurInfoVoNull ? <></> : <div className={styles['page']}>
        <PageFour
          rangeName={nameObj?.rangeName}
          surroundingInfoVO={data?.surroundingInfoVO}
          lnglat={lnglat}
          range={range}/>
      </div>}

      <div className={styles['page']}>
        <PageFive
          storeFormatVO={data?.storeFormatVO}
          rangeName={nameObj?.rangeName}
          centerCategoryVo={data?.centerCategoryVo}
          qrCode={qrCode}/>
      </div>

      <div className={styles['page']}>
        <PageSix
          storeOprationInfo={data?.storeOprationInfo}
          storeSurvivalRateInfo={data?.storeSurvivalRateInfo}
          rangeName={nameObj?.rangeName}
          qrCode={qrCode}/>
      </div>

      <div className={styles['page']}>
        <LastPage qrCode={qrCode}/>
      </div>
    </div>
  );
};

export default LocationSrounding;
